import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

import * as _ from 'lodash';
import { filter } from 'rxjs/operators';

import { DrawerBase, DrawerSettings, DrawerRefBase, DrawerParamsBase } from './drawer.base';

//
//// Example ////
//
// private drawer: Drawer;
//
// private openModal() {
//   if(!this.drawer) {
//     this.drawer = this.drawerService.create(TesteModal, {
//       // Drawer params (Opcional)
//       teste: {
//         'its work?': true
//       }
//     }, {
//        // Drawer settings (Opcional)
//        backdrop: {                             // Backdrop settings (Opcional)
//          onClick: 'close'                      // Opcional: 'close', 'dismiss', 'none' (default: close)
//        },
//        header: {                               // Header settings (Opcional)
//          title: 'Teste modal',                 // ObrigatÃ³rio
//          subtitle: 'Isso Ã© apenas um teste',   // Opcional
//          closable: true,                       // Opcional (default: true)
//          closeClick: 'close'                   // Opcional: 'close', 'dismiss' (default: close)
//        }
//     });
//     // Quando o modal Ã© aberto
//     this.drawer.onOpen.subscribe(() => console.log("Modal opened"));
//     // Quando o drawer Ã© ocultado
//     this.drawer.onDismiss.subscribe(() => console.log("Modal dismissed"));
//     // Quando o drawer Ã© destruido
//     this.drawer.onClose.subscribe(() => console.log("Modal closed"));
//     // Quando o drawer retorna um valor
//     this.drawer.onReturnValue.subscribe((response) => console.log("Modal response:", response));
//   }
//   this.drawer.open();
// }
//

@Injectable()
export class DrawerService {

  constructor(
    private _router: Router
  ) {
    document.addEventListener('keyup', (event) => {
      const keyCode = event.which || event.keyCode;
      if ([
        13,   // Return
        27    // Escape
      ].indexOf(keyCode) > -1) {
        const visible_drawers = this.drawers.filter((dialog) => dialog.visible);
        if (visible_drawers.length > 0) {
          const last_visible_drawers = _.last(visible_drawers);
          let handler = null;
          if (!last_visible_drawers.settings.keyboard) { return; }
          switch (keyCode) {
            case 13: handler = last_visible_drawers.settings.keyboard.onReturn; break;
            case 27: handler = last_visible_drawers.settings.keyboard.onEscape; break;
          }
          if (_.isFunction(handler)) {
            handler();
          } else {
            switch (handler) {
              case 'close':
                event.preventDefault();
                last_visible_drawers.close();
                break;
              case 'dismiss':
                event.preventDefault();
                last_visible_drawers.dismiss();
                break;
              default:
                return;
            }
          }
        }
      }
    }, true);

    this._router.events
    .pipe(filter((e) => e.constructor == NavigationEnd))
    .subscribe(() => {
      this.drawers.forEach((drawer) => {
        if (!drawer.destroyed && drawer.close_on_route_change) { drawer.close(); }
      });
    });
  }

  public drawers: Array<Drawer> = [];

  private _current_index = 0;

  private _zindex = 10010;
  private _content_zindex = 10020;
  private _backdrop_zindex = 10000;

  public create(component: any, params?: any, settings?: DrawerSettings): Drawer {
    if (!(params && _.isPlainObject(params))) { params = {}; }
    const data = {
      component: component,
      params: params,
      settings: settings,
      zindex: this._zindex,
      _content_zindex: this._content_zindex,
      _backdrop_zindex: this._backdrop_zindex
    };

    this._zindex += 100;
    this._content_zindex += 100;
    this._backdrop_zindex += 100;

    const drawer_instance = new Drawer(this.drawers, data, this._current_index);

    this._current_index++;

    return drawer_instance;
  }

  public open(component: any, params?: any, settings?: DrawerSettings): Drawer {
    if (!(params && _.isPlainObject(params))) { params = {}; }
    const instance = this.create(component, params, settings);
    instance.open();
    return instance;
  }

}

export class Drawer extends DrawerBase {}

export class DrawerRef extends DrawerRefBase {}

export class DrawerParams extends DrawerParamsBase {}
